<template>
    <div>
        <my-header @userInfo="getuserInfo"></my-header>
        <div class="member">
            <div class="content">
                <div class="member-header">
                    <img src="@images/subscribe/subscribe_logo.png" alt="" />
                    <h1>办理订阅</h1>
                    <div class="bothclear"></div>
                </div>
                <div class="hysection">
                    <el-form
                        :inline="true"
                        :model="pgData"
                        ref="form"
                    >
                        <el-form-item>
                            <el-input placeholder="请输入受益人" v-model="pgData.profitname" size="small" clearable></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-select v-model="pgData.producttype" :popper-append-to-body="false" popper-class="product-select" clearable placeholder="请选择产品类型" size="small">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-date-picker
                                v-model="time"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="持续时间早至"
                                end-placeholder="持续时间晚至"
                                size="small">
                            </el-date-picker>
                        </el-form-item>

                        <div class="form-btn">
                            <el-button type="primary" icon="el-icon-search" size="small" @click="getDataList">查询</el-button>
                            <el-button type="success" icon="el-icon-plus" size="small" @click="dialogVisible = true">添加</el-button>
                        </div>
                    </el-form>
                </div>

                <div class="data-list" v-loading="loading" v-if="dataList && dataList.length > 0">
                    <card v-for="item in dataList" :key="item.guid" >
                        <template slot="head">
                            <el-tag v-if="item.status == '1'" size="medium" type="success">已生效</el-tag>
                            <el-tag v-if="item.status == '0'" size="medium" type="info">已过期</el-tag>
                        </template>
                        <card-item head="受益人">
                            <div>{{item.profitname}}</div>
                        </card-item>

                        <card-item head="产品">
                            <div v-for="(content,index) in item.productname.split(',')" :key="index">
                                {{content}}
                            </div>
                        </card-item>

                        <card-item head="持续时间" width="380px">
                            <div>{{`${item.pushstarttime} 至 ${item.pushendtime}`}}</div>
                        </card-item>

                        <card-item head="推送地址" >
                            <div style="word-break:break-all;" v-for="(content,index) in item.receivers.split(',')" :key="index">
                                {{content}}
                            </div>
                        </card-item>

                        <card-item head="已推送数量" width="100px">
                            <div>{{item.pushednum}}</div>
                        </card-item>

                        <el-button slot="footer" type="text" icon="el-icon-delete" size="small" @click="del(item)">删除</el-button>
                    </card>
                </div>
                <card v-else>
                    <el-empty  :image-size="200"></el-empty>
                </card>
                
            </div>
        </div>

        <div>
            <el-dialog
            title="添加"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            width="50%"
            >
                <add-form @close="close"></add-form>
            </el-dialog>
        </div>
        
    </div>
</template>

<script>
import CardItem from './components/card-item.vue';
import Card from './components/card.vue';
import addForm from './components/form.vue'
import CONFIG from './config/index'
export default {
    components:{addForm,Card, CardItem },
    head: {
        title: '会员服务·电子保函查验平台'
    },
    data: () => ({
        userInfo:'',
        pgData:{
            producttype:'',
            starttime:'',
            endtime:''
        },
        options: CONFIG.bhType,
        dataList:[],
        dialogVisible:false,
        loading:false
    }),
    computed: {
        time: {
            get() {
                let startTime = this.pgData.starttime || '',
                    endTime = this.pgData.endtime;
                    
                if(startTime && endTime){
                    return [
                        startTime,
                        endTime
                    ];   
                } else {
                    return [];
                }
            },
            set(val) {
                if(!val) {
                    this.pgData.starttime = '';
                    this.pgData.endtime = ''
                }else{
                    let startTime = val[0] || '',
                    endTime = val[1] || '';
                    this.pgData.starttime = startTime;
                    this.pgData.endtime = endTime;  
                } 
            }
        },
    },
    methods: {
        getuserInfo(data){
            this.userInfo=data;
        },
        getDataList(){
            this.loading = true
            this.$get(`${this.$store.state.api.webUrl}/msgpush/list`,this.pgData, (data,res) => {
                if(res.msg == '未登录'){
                    this.unLogin(res.msg);
                }
                this.dataList = data;
                this.loading = false;
            }); 
        },
        close(){
            this.dialogVisible = false;
            this.getDataList();
        },
        /**
         * 删除
         * @param {Object} row 所选中行
         */
        del(row){
            this.$confirm('确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post(`${this.$store.state.api.webUrl}/msgpush/delete`,{
                    ruleid:row.rowguid
                }, (data,res) => {
                    this.$notify({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getDataList();
                }); 
            }).catch(() => {
                this.$notify.info({
                    message: '已取消删除'
                });         
            });
        },
        /**
         * 未登录
         * @param {String} msg 消息
         */
        unLogin(msg){
            this.$alert(msg, '提示', {
                confirmButtonText: '确定',
                type:"error",
                callback: action => {
                    this.goto('/login')
                }
            });
        }
    },
    created() {},
    mounted() {
        this.getDataList();
    }
}
</script>

<style lang="scss" scoped>
    .header{
        background-image: url(~@images/guarantee/banner2.jpg);  
        background-repeat: no-repeat;
        background-position:0 -56px;
        background-size:cover;         
    }
    .bothclear{
        clear:both;
    }
    .member{
        font-family: Microsoft YaHei;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        min-height:592px;
        background: #f9fafb;
        padding-bottom: 85px;
        .content{
            .member-header{
                width:100%;
                padding:40px 0 35px 0;
                line-height:38px;
                img{
                    display:block;
                    float: left;
                }
                h1{
                    float: left;
                    font-size: 30px;
                    margin-left:21px;
                }
            }

            .hysection{
                width: 100%;
                background-color: #ffffff;
                box-shadow: 0px 3px 12px 0px  rgba(152, 157, 171, 0.08);
                padding:32px 50px 6px 50px;
                margin-bottom:20px;
                border-radius: 4px;

                .form-btn {
                    float: right;
                }
            }
            .ktmember{
                display: block;
                cursor: pointer;
                width: 164px;
                height: 58px;
                line-height: 58px;
                text-align: center;
                margin:0 auto;
                background-color: #ffb73b;
                color:#ffffff;
                font-size: 22px;
                border-radius: 4px;
                &:hover{
                    opacity: 0.8;
                }
            }
            .data-list{
                min-height: 500px;
            }
        }
    }
   
</style>
